import Vue from 'vue'
import Router from 'vue-router'
import Help from '../components/Help'
import Home from '../components/Home'
import Queue from '../components/Queue'
import Task from '../components/Task'
import Compounds from '../components/Compounds'
import Targets from '../components/Targets'
import Fragments from '../components/Fragments'
import Statistics from '../components/Statistics'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },

    {
      path: '/help',
      name: 'Help',
      component: Help
    },

    {
      path: '/home',
      name: 'Home',
      component: Home
    },

    {
      path: '/queue',
      name: 'Queue',
      component: Queue
    },

    {
      path: '/task/:id',
      redirect: '/task/:id/0/Targets'
    },

    {
      path: '/task/:id/:icompound',
      component: Task,
      children: [
        {
          path: '',
          redirect: {
            name: 'Targets'
          }
        },
        {
          path: 'compounds',
          name: 'Compounds',
          component: Compounds
        },
        {
          path: 'targets',
          name: 'Targets',
          component: Targets
        },
        {
          path: 'fragments',
          name: 'Fragments',
          component: Fragments
        },
        {
          path: 'Statistics',
          name: 'Statistics',
          component: Statistics
        }
      ]
    }
  ]
})
